// extracted by mini-css-extract-plugin
export var columnList = "_gb-0";